var React = require('react');

function MailFill (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.34276 21.1406C5.62534 15.8938 10.358 12 16 12H80C85.6423 12 90.375 15.8941 91.6574 21.1413L85.9426 24.5701C85.9133 24.5877 85.8842 24.6057 85.8553 24.6241L49.9969 47.4104L49.988 47.416C49.3917 47.7873 48.7032 47.9842 48.0006 47.9842C47.298 47.9842 46.6095 47.7873 46.0132 47.416L10.1459 24.6241C10.117 24.6057 10.0879 24.5877 10.0586 24.5701L4.34276 21.1406ZM4 30.2645V72C4 78.6274 9.37258 84 16 84H80C86.6274 84 92 78.6274 92 72V30.2652L90.1026 31.4037L54.2444 54.1898C52.3729 55.3624 50.209 55.9842 48.0006 55.9842C45.7922 55.9842 43.6284 55.3623 41.7569 54.1898L41.7352 54.1762L5.8986 31.4037L4 30.2645Z","fill":"#130A09"}));
}

MailFill.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = MailFill;

MailFill.default = MailFill;
